import React from 'react';
import OnePagerBarChart from './OnePagerBarChart';
import PdfCompositionChart from './PdfCompositionChart';
import { CompositionSector, SECTORS_CODES } from '../utils/compositionChart';

export interface OnePagerCompositionChartProps {
  sectors: CompositionSector[];
  colors: string[];
  dataSize: number;
  isPdfExport?: boolean;
  emptyStateText?: string;
}

const OnePagerCompositionChart = ({ sectors, colors, dataSize, isPdfExport = false, emptyStateText }: OnePagerCompositionChartProps) => {
  if (isPdfExport) return <PdfCompositionChart sectors={sectors} colors={colors} emptyStateText={emptyStateText} />;
  return (
    <>
      {sectors.filter(sector => SECTORS_CODES.includes(sector.region)).map((sector, index) => (
        <OnePagerBarChart key={sector.region} bgColors={colors[index]} barChartData={sector} size={dataSize} />
      ))}
    </>
  );
};

export default OnePagerCompositionChart;
